<template>
    <div v-bind:class="{show : dialogueVisible == true, displayblock : dialogueVisible == true}" class="modal sustainable-component update-example-company" tabindex="-1" v-bind:id="'customModal' + getId()" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header bg-primary">
                    Uppdatera exempelbolag
                </div>

                <div class="modal-body pb-0">
                    <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
                        {{errorMessage}}
                    </v-snackbar>
                    <common-spinner v-bind:loading="loading > 0"></common-spinner>
                    <div class="container-fluid p-0">
                        <div class="row">
                            <v-form v-model="valid" ref="form">
                                <div class="container-fluid p-0">
                                    <div class="row">
                                        <div class="col">
                                            <v-text-field bg-color="white"
                                                          name="CompanyName"
                                                          id="CompanyName"
                                                          type="text"
                                                          label="Företag"
                                                          variant="outlined"
                                                          v-model="company.Name"
                                                          disabled></v-text-field>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <v-text-field bg-color="white"
                                                          name="Category"
                                                          id="Category"
                                                          type="text"
                                                          label="Kategori"
                                                          variant="outlined"
                                                          v-model="company.Category"></v-text-field>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <v-select name="Role"
                                                      v-model="company.Role"
                                                      item-title="name"
                                                      item-value="val"
                                                      :items="roleOptions"
                                                      label="Roll"></v-select>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col">
                                            <v-select name="Department"
                                                      v-model="company.DepartmentId"
                                                      item-title="DepartmentName"
                                                      item-value="DepartmentId"
                                                      :items="departments"
                                                      label="Avdelning"></v-select>
                                        </div>
                                    </div>
                                </div>
                            </v-form>
                        </div>
                    </div>
                </div>
                <div class="modal-footer pt-2 pb-1">
                    <v-btn color="blue-darken-1"
                           variant="text"
                           @click="close">
                        Stäng
                    </v-btn>
                    <v-btn color="blue-darken-1"
                           variant="text"
                           @click="save">
                        Spara
                    </v-btn>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { getCurrentInstance } from 'vue'
    import ValidationService from "../../../Services/ValidationService";
    import AdminService from "../../../Services/AdminService";
    import CommonSpinner from '../../../common/common-spinner.vue'
    import { ref } from 'vue'
    const form = ref(null);

    export default {
        emits: ['updated'],
        name: 'update-example-company',
        components: {
            CommonSpinner
        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            close() {
                this.reset();
                this.dialogueVisible = false;
                this.thisModal.hide();
            },
            async open(company) {
                this.company = {
                    ...company,
                    Category: company.Category || '',
                    Role: company.Role || 0,
                    DepartmentId: company.DepartmentId || 0
                };
                this.dialogueVisible = true;
                this.thisModal.show();
            },
            async loadDepartments() {
                this.loading++;
                try {
                    this.departments = [{ DepartmentName: 'Ingen vald', DepartmentId: 0 }, ...await AdminService.getDepartments()];
                }
                catch (error) {
                    this.displayErrorSnackBar("Det gick inte att läsa in avdelningar");
                }
                this.loading--;
            },
            async save() {
                var result = await this.form.validate();
                if (result.valid != true)
                    return;

                this.loading++;
                try {
                    await AdminService.updateExampleCompany(this.company);
                    this.reset();
                    this.dialogueVisible = false;
                    this.thisModal.hide();
                    this.$emit("updated");
                }
                catch (error) {
                    this.displayErrorSnackBar("Det gick inte att uppdatera exempelbolaget");
                }
                this.loading--;
            },
            reset() {
                this.company = {
                    Id: 0,
                    CompanyId: 0,
                    Name: '',
                    Category: '',
                    DepartmentId: 0,
                    Role: 0
                };
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            }
        },
        data() {
            return {
                rules: ValidationService.rules(),
                dialogueVisible: false,
                thisModal: {},
                showErrorMessageSnackBar: false,
                errorMessage: null,
                loading: 0,
                company: {
                    Id: 0,
                    CompanyId: 0,
                    Name: '',
                    Category: '',
                    DepartmentId: 0,
                    Role: 0
                },
                departments: [],
                roleOptions: [
                    { name: 'Ingen roll', val: 0 },
                    { name: 'Superadmin', val: 10 },
                    { name: 'Avdelningsadministratör', val: 15 },
                    { name: 'Administratör', val: 20 },
                    { name: 'Användare', val: 30 }
                ]
            };
        },
        mounted() {
            this.loadDepartments();

            this.$el.remove();
            document.body.appendChild(this.$el);

            // eslint-disable-next-line
            this.thisModal = new bootstrap.Modal(document.getElementById('customModal' + this.getId()), {});
        },
        setup() {
            return { form }
        }
    }
</script>

<style scoped>
    .modal-content {
        border-radius: unset;
    }

    .modal-footer {
        border-top-color: transparent;
    }

    .modal-header {
        border-top-left-radius: unset;
        border-top-right-radius: unset;
    }
</style>
